import {
    prepareSubmitFormData
} from "../../../../../../../../plugins/growtype-quiz/resources/js/actions/question/prepareSubmitFormData";

export function autosliders() {
    const steps = $(".quiz-autosliders .quiz-step");
    const totalDuration = 3000; // total slider duration in ms
    const totalProgress = 100;

    let quizWrapper = steps.closest('.growtype-quiz-wrapper');
    let quizId = quizWrapper.attr('id');
    let answers = {};

    function runStep(index) {
        if (index >= steps.length) {
            let redirectUrl = $('.growtype-quiz-loader-wrapper').attr('data-redirect-url');

            let formData = prepareSubmitFormData(quizId, answers);

            formData.append("update_quiz_data", true);

            $.ajax({
                url: growtype_quiz_local.ajax_url,
                type: "post",
                processData: false,
                contentType: false,
                cache: false,
                enctype: 'multipart/form-data',
                data: formData,
                success: function (data) {
                    window.location.replace(redirectUrl);
                },
                error: function (data) {
                    window.location.replace(redirectUrl);
                }
            })

            return;
        }

        const step = steps[index];
        const fill = step.querySelector(".quiz-step__bar-fill");
        const percentLabel = step.querySelector(".quiz-step__percent strong");
        let progress = 0;
        let paused = false;

        // Popup content from attributes
        const popupTitle = step.dataset.popupTitle || "";
        const popupText = step.dataset.popupText || "";
        const backgroundUrl = step.dataset.backgroundUrl || "";
        const currentQuestionKey = step.dataset.key;

        // Random pause between 20% and 80%
        const pauseAt = Math.floor(Math.random() * 60) + 20;

        // Generate random intervals to simulate realistic load
        let intervals = [];
        let remainingTime = totalDuration;
        for (let i = 0; i < totalProgress; i++) {
            // Randomize interval between 10–40ms per step, but adjust to keep total ~totalDuration
            const maxInterval = Math.min(remainingTime - (totalProgress - i - 1) * 10, 40);
            const interval = Math.floor(Math.random() * maxInterval) + 10;
            intervals.push(interval);
            remainingTime -= interval;
        }

        let stepIndex = 0;

        function nextStep() {
            if (stepIndex >= totalProgress) {
                setTimeout(() => runStep(index + 1), 500);
                return;
            }

            progress++;
            fill.style.width = progress + "%";
            percentLabel.textContent = progress + "%";

            // Random jitter to simulate "calculating" effect
            if (Math.random() < 0.05 && progress < 95) {
                fill.style.width = (progress - 1) + "%"; // temporary slight rollback
            }

            // Show popup if pauseAt reached and title exists
            if (!paused && progress === pauseAt && popupTitle) {
                paused = true;
                showPopup(popupTitle, popupText, backgroundUrl, () => {
                    paused = false;
                    stepIndex++;
                    nextStep();
                }, currentQuestionKey);
                return;
            }

            stepIndex++;
            setTimeout(nextStep, intervals[stepIndex - 1]);
        }

        nextStep();
    }

    // --- Popup UI ---
    function showPopup(title, text, backgroundUrl, onClose, currentQuestionKey) {
        const popup = document.createElement("div");
        popup.className = "quiz-popup";

        let backgroundContent = "";
        if (backgroundUrl) {
            if (backgroundUrl.match(/\.(mp4|webm|ogg)$/i)) {
                backgroundContent = `
                    <div class="quiz-popup__video-wrapper">
                        <video class="quiz-popup__video" autoplay muted loop playsinline>
                            <source src="${backgroundUrl}" type="video/mp4">
                        </video>
                    </div>`;
            } else if (backgroundUrl.match(/\.(jpg|jpeg|png|gif|webp)$/i)) {
                backgroundContent = `<img class="quiz-popup__image" src="${backgroundUrl}" alt="">`;
            }
        }

        popup.innerHTML = `
            <div class="quiz-popup__overlay"></div>
            <div class="quiz-popup__content">
                ${backgroundContent}
                <div class="quiz-popup__text">
                    <h3>${title}</h3>
                    ${text ? `<p>${text}</p>` : ''}
                    <div class="quiz-popup__buttons">
                        <button class="quiz-popup__button quiz-popup__button--yes">Yes</button>
                        <button class="quiz-popup__button quiz-popup__button--no">No</button>
                    </div>
                </div>
            </div>
        `;
        document.body.appendChild(popup);

        const closePopup = (clickedYes = false) => {
            popup.remove();

            if (currentQuestionKey) {
                if (clickedYes) {
                    // Store 'true' if Yes clicked
                    answers[currentQuestionKey] = ['true'];
                } else if (answers[currentQuestionKey]) {
                    // Remove key if it exists and clickedYes is false
                    delete answers[currentQuestionKey];
                }
            }

            onClose();
        };

        popup.querySelector(".quiz-popup__button--yes").addEventListener("click", () => closePopup(true));
        popup.querySelector(".quiz-popup__button--no").addEventListener("click", () => closePopup(false));
    }

    runStep(0);
}
